
enum enmRole {
    L0 = 1,
    L1 = 2,
    L2 = 3,
    L3 = 4, 
}
export default enmRole;